module.exports = __webpack_public_path__ + "img/date_icon.ae99e4cb.svg";